import React, { useState, useEffect } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../../shared/config";
import * as util from '../../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';

export default function ChangePassword(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect(() => {
    }, []);
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "currentPassword") setCurrentPassword(val);
        else if(name === "newPassword") setNewPassword(val);
        else if(name === "confirmPassword") setConfirmPassword(val);
    }
    const checkDataEntry = function(){
        if (currentPassword === "") {
            setErrorMessage("کلمه عبور فعلی را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        if (newPassword === "") {
            setErrorMessage("کلمه عبور جدید را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        if (confirmPassword === "") {
            setErrorMessage("تکرار کلمه عبور را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if (confirmPassword != newPassword) {
            setErrorMessage("کلمه عبور با تکرار آن یکسان نمی باشد");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
        if (!checkDataEntry()) return;
        var params = {
            login: util.getLoginDto(), currentPassword: currentPassword, newPassword: newPassword
        };
        setSaving(true);
        var url = config.Server + `/user/change/password`;
        axios
        .post(url, params)
        .then(res => {
            var response = res.data;
            if (response.state === "ok") {
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("")
                setErrorMessage("با موفقیت ثبت گردید");
                setErorVisible(true);
                setSaving(false);
                //setRedirectUrl("/home")
            }
            else {
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../../lib/images/reset-pass-icon.png')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>ثبت کلمه عبور جدید</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"rtl"}}>
                                        <FloatLabel>
                                        <Password value={currentPassword} onChange={(e) => { onInputChange(e, "currentPassword") }} id="newPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                            iconField: {
                                            root: {
                                                style: { width: "100%", },
                                            },
                                            },
                                            input: {
                                            style: { width: "100%", textAlign: "center" },
                                            },
                                            root: {
                                            style: { width: "100%" },
                                            },
                                        }} toggleMask feedback={false} />
                                        <label htmlFor="password">کلمه عبور فعلی</label>
                                        </FloatLabel>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em"}}>
                                        <FloatLabel>
                                        <Password value={newPassword} onChange={(e) => { onInputChange(e, "newPassword") }} id="newPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                            iconField: {
                                            root: {
                                                style: { width: "100%" },
                                            },
                                            },
                                            input: {
                                            style: { width: "100%", textAlign: "center" },
                                            },
                                            root: {
                                            style: { width: "100%" },
                                            },
                                        }} toggleMask feedback={false} />
                                        <label htmlFor="password">کلمه عبور جدید</label>
                                        </FloatLabel>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                        <Password value={confirmPassword} onChange={(e) => { onInputChange(e, "confirmPassword") }} id="confirmPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                            iconField: {
                                            root: {
                                                style: { width: "100%" },
                                            },
                                            },
                                            input: {
                                            style: { width: "100%", textAlign: "center" },
                                            },
                                            root: {
                                            style: { width: "100%" },
                                            },
                                        }} toggleMask feedback={false} />
                                        <label htmlFor="password">تکرار کلمه عبور</label>
                                        </FloatLabel>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{saveItem()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;ثبت کلمه عبور جدید&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}